export const isPlatformPaySupported = () => Promise.resolve(true)
